const id_sales_so = {
    "": "sales order",
    add: "buat sales order",
    detail: "detail sales order",
    do: "sales order (DO OUT)",
    edit: "ubah sales order",
    po: "purchase order masuk",
    po_detail: "detail purchase order masuk",

    label: {
        btn_po: "PO masuk - mitra",
        btn_createDO: "buat barang keluar",
        btn_reset_goods: "atur ulang barang",
        no_so_ref: "nomor SO / nomor referensi",
    },

    message: {
        delete_title: "Apakah Anda yakin untuk menghapus SO?",
        delete_text: "Masukkan alasan pembatalan SO.",
        reject_title: "Apakah Anda yakin untuk membatalkan SO?",
        reject_text: "Masukkan alasan pembatalan SO.",
    },

    error: {
        create: "Gagal membuat SO.",
        create_do: "Gagal membuat referensi barang keluar (DO OUT).",
        delete: "Gagal membatalkan SO.",
        edit: "Gagal mengubah SO.",

        reject: "Gagal membatalkan SO.",
        approve: "Gagal mengonfirmasi SO.",
        done: "Gagal menyelesaikan SO.",
    },

    success: {
        create: "Berhasil membuat SO.",
        create_do: "Berhasil membuat referensi barang keluar (DO OUT).",
        delete: "Berhasil membatalkan SO.",
        edit: "Berhasil mengubah SO.",

        reject: "Berhasil membatalkan SO.",
        approve: "Berhasil mengonfirmasi SO.",
        done: "Berhasil menyelesaikan SO.",
    },
}

export default id_sales_so;